import { render, staticRenderFns } from "./AwaitApprovalModal.vue?vue&type=template&id=98328d16&"
import script from "./AwaitApprovalModal.vue?vue&type=script&lang=js&"
export * from "./AwaitApprovalModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports